import { render, staticRenderFns } from "./ShowDetail.vue?vue&type=template&id=5bccfb18&scoped=true&"
import script from "./ShowDetail.vue?vue&type=script&lang=js&"
export * from "./ShowDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShowDetail.vue?vue&type=style&index=0&id=5bccfb18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bccfb18",
  null
  
)

export default component.exports